import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useButtonText } from './utils';
import { useSubmitClickHandler } from './utils/useSubmitClickHandler';
import { submitValuationForm } from '../../actions/submitValuationForm';
import { OpenDataPaymentForm } from '../../components/OpenDataPaymentForm';
import { selectCheckEstimationExists } from '../../selectors/checkEstimationExists/selectCheckEstimationExists';

export const ValuationSubmitDesktopContainer: React.FC = () => {
  const { isNotFound, isFetching, estimationId } = useSelector(selectCheckEstimationExists);
  const dispatch = useDispatch();
  const submitText = useButtonText({ isSubmit: true });

  const handleClick = useSubmitClickHandler();

  /**
   * При клике на плашку "Кажется, вы уже оценивали эту квартиру"
   * редирект на страницу результатов оценки
   */
  const handleClickEstimationReady = React.useCallback(() => {
    dispatch(submitValuationForm());
  }, [dispatch]);

  return (
    <OpenDataPaymentForm
      onClick={handleClick}
      isLoading={isFetching}
      disabled={isNotFound}
      isNotFound={isNotFound}
      onEstimationReadyClick={handleClickEstimationReady}
      isEstimationReady={Boolean(estimationId)}
      submitText={submitText}
    />
  );
};
